module.exports = __webpack_public_path__ + "static/media/puzzle.6476b15d.png";